import api from '../../api/api';
import * as ACTIONS from '../actionTypes';
import * as MUTATION from '../mutationTypes';

export default {
  [ACTIONS.PAYMENT_BUY]: async (_, params) => {
    return await api.paymentApi.buy(params);
  },
  [ACTIONS.GET_PACKAGES]: async ({commit}, params = {}) => {
    if (!params?.hasOwnProperty('limit')) {
      params.no_limit = 1;
    }
    return await api.paymentApi.packages(params);
  },
  [ACTIONS.GET_SUBSCRIPTIONS]: async ({commit}, params = {}) => {
    if (!params?.hasOwnProperty('limit')) {
      params.no_limit = 1;
    }
    return await api.paymentApi.subscriptions(params);
  },
  [ACTIONS.GET_PACKAGE]: async (state, params) => {
    return await api.paymentApi.package(params);
  },
  [ACTIONS.GET_SUBSCRIPTION]: async (state, params) => {
    return await api.paymentApi.subscription(params);
  },
  [ACTIONS.GET_ORDERS]: async ({commit}, params) => { // TODO: remove
    const orders = await api.paymentApi.orders(params);
    commit(MUTATION.UPDATE_ORDERS_LIST, orders.data);
    return orders.data;
  },
  [ACTIONS.GET_ORDER_BY_ID]: async (_, {order_id: orderId} = {}) => {
    if (!orderId) return false;
    return await api.paymentApi.orderById({orderId});
  },
  [ACTIONS.APPLY_COUPON]: async (_, params) => {
    return await api.paymentApi.applyCoupon(params);
  },
  [ACTIONS.UNSUBSCRIBE]: async (_, params) => {
    return await api.paymentApi.unsubscribe(params);
  },
  [ACTIONS.GET_STRIPE_PORTAL]: async () => {
    return await api.paymentApi.getStripePortal();
  },
  [ACTIONS.OPEN_STRIPE_PORTAL]: async () => {
    return await api.paymentApi.getStripePortal().then(({data}) => {
      if (data) {
        if (/Mac OS X/.test(navigator.userAgent)) {
          location.href = data;
        } else {
          window.open(data, '_blank').focus();
        }
      }
    });
  },
  [ACTIONS.GET_USER_CARDS]: async () => {
    return await api.paymentApi.getUserSavedCards();
  },
  [ACTIONS.START_TRIAL]: async (_, {id, ...rest}) => {
    return await api.paymentApi.startTrial({
      subscription_id: id,
      ...rest,
    });
  },
  [ACTIONS.GET_CLIENT_SECRET_STRIPE]: async (_, params) => {
    return await api.paymentApi.getClientSecretStripe(params);
  },
  [ACTIONS.GET_INVOICE_PREVIEW]: async (_, params) => {
    return await api.paymentApi.invoicePreview(params);
  },
  [ACTIONS.BUY_BUNDLE]: async (_, params) => {
    return await api.paymentApi.buyBundle(params);
  },
  [ACTIONS.GET_PURCHASED_PASSES]: async ({commit}) => {
    const data = await api.paymentApi.getPurchasedPasses();
    commit(MUTATION.UPDATE_PURCHASED_PASSES, data);
    return data;
  },
  [ACTIONS.CANCEL_SUBSCRIPTION]: async (_, {subscriptionId}) => {
    return await api.paymentApi.cancelSubscription({subscriptionId});
  },
};
